export default "<button class=\"btn btn-primary btn-raised\" ng-click=\"scan()\">\n    <i class=\"fas fa-qrcode\"></i>\n    &nbsp;{{ title }}\n</button>\n"